import BlogLayout from '../../layout/BlogLayout'
import Image1 from '../../assets/blog/article-5/1.webp'
import Image2 from '../../assets/blog/article-5/2.webp'
import Image3 from '../../assets/blog/article-5/3.webp'
import Image4 from '../../assets/blog/article-5/4.webp'
import Image5 from '../../assets/blog/article-5/5.webp'
import Image6 from '../../assets/blog/article-5/6.webp'
import Image7 from '../../assets/blog/article-5/7.webp'

const Article5 = () => {
  return (
    <BlogLayout
      category='Evento'
      title='VIDA en Experiencia Endeavor 2026: conexiones reales, comunidad en acción'
    >
      <p>
        El pasado <strong>jueves 14 de mayo</strong> fuimos parte de la{' '}
        <strong>Experiencia Endeavor 2026</strong>, una jornada que reunió a emprendedores,
        empresarios, referentes y proyectos con una misma intención: encontrarse, compartir
        ideas y seguir construyendo comunidad.
      </p>

      <img src={Image2} alt="Blog" className="img--medium" />

      <p>
        Para nosotros, como equipo de <strong>VIDA Cowork</strong>, participar de este tipo
        de espacios representa mucho más que estar presentes en un evento. Es la posibilidad
        de seguir vinculados a conversaciones donde se cruzan la innovación, la comunicación,
        los negocios y la visión estratégica sobre el futuro del trabajo y del emprendedurismo.
      </p>

      <p className='blog-subtitle'>El desafío: conexiones reales, no superficiales</p>

      <p>
        Uno de los grandes desafíos de esta edición fue pensar cómo generar{' '}
        <strong>conexiones reales</strong> entre las personas. ¿Cómo hacer para que un
        espacio de networking trascienda el intercambio superficial y se convierta en una
        experiencia significativa? A partir de esa pregunta nació una propuesta de dinámicas
        diseñadas para impulsar encuentros genuinos entre jóvenes empresarios, emprendedores
        y personas con ganas de compartir sus proyectos en comunidad.
      </p>

      <img src={Image3} alt="Blog" className="img--large" />

      <p>
        Y como creemos profundamente en el trabajo colaborativo, este desafío no lo llevamos
        adelante solos.
      </p>

      <p className='blog-subtitle'>Aliados que hicieron posible la experiencia</p>

      <p>
        Junto a{' '}
        <a href="https://www.instagram.com/upcompany.arg/" target="_blank" rel="noopener noreferrer">
          UP COMPANY
        </a>{' '}
        desarrollamos experiencias pensadas para facilitar <strong>vínculos auténticos</strong>{' '}
        y conversaciones capaces de transformarse en oportunidades reales. Porque muchas veces,
        el crecimiento de un proyecto comienza a partir de una conexión correcta en el momento
        indicado.
      </p>

      <img src={Image1} alt="Blog" className="img--large" />

      <p>
        El espacio también cobró vida gracias al trabajo y la mirada de{' '}
        <a href="https://www.instagram.com/cohabitando_bioarq/" target="_blank" rel="noopener noreferrer">
          CO HABITANDO
        </a>
        , quienes diseñaron una propuesta cálida y humana, acompañados por la esencia verde y
        natural de{' '}
        <a href="https://www.instagram.com/ciudadguna/" target="_blank" rel="noopener noreferrer">
          CIUDAD GUNA
        </a>
        , que aportó identidad y bienestar a toda la experiencia.
      </p>

      <img src={Image4} alt="Blog" className="img--large" />


      <p className='blog-subtitle'>Lo que nos llevamos</p>

      <p>
        Ser parte de una experiencia de esta magnitud reafirma nuestra visión sobre el valor
        de las <strong>comunidades</strong>, las <strong>alianzas estratégicas</strong> y los
        espacios que impulsan conversaciones con impacto real.
      </p>

      <p>
        Nos vamos muy contentos por lo vivido, por las conexiones que surgieron y por todo lo
        que esta experiencia dejó tanto a nivel profesional como humano. Sin dudas, este es el
        puntapié para seguir creando encuentros donde la <strong>experiencia VIDA</strong>{' '}
        pueda habitar cualquier espacio al que lleguemos. Porque más allá de un lugar físico,
        <strong> VIDA es una forma de conectar, trabajar y construir comunidad</strong>.
      </p>

      <img src={Image7} alt="Blog" className="img--large" />
    </BlogLayout>
  )
}

export default Article5
